var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import { Nav, Navbar, NavDropdown } from "react-bootstrap";
var SimpleNavbar = /** @class */ (function (_super) {
    __extends(SimpleNavbar, _super);
    function SimpleNavbar(props) {
        return _super.call(this, props) || this;
    }
    SimpleNavbar.prototype.render = function () {
        return (React.createElement(Navbar, { bg: "primary", variant: "dark" },
            React.createElement(Navbar.Brand, { href: this.props.brand.href }, this.props.brand.title),
            React.createElement(Nav, { className: "mr-auto" }, this.props.sections.map(function (section) { return (React.createElement(NavDropdown, { title: section.title, id: section.id }, section.items.map(function (item) { return (React.createElement(NavDropdown.Item, { href: item.href, key: item.key }, item.title)); }))); }))));
    };
    return SimpleNavbar;
}(Component));
export { SimpleNavbar };
//# sourceMappingURL=SimpleNavbar.js.map